<template>
  <div class="base-config">
    <a-alert
      type="warning"
      class="clearfix"
    >
      <div
        slot="description"
      >
        <i class="iconfont iconicon-test68-copy fs-warn fl" />
        请不要随意变更基础配置，这可能导致从星轨同步数据到小满的功能不可用。
      </div>
    </a-alert>

    <div class="content">
      <!-- 开启集成： -->
      <div class="row clearfix">
        <label class="fl">开启集成：</label>
        <div class="item-wrap">
          <a-switch
            :checked="!!data.isopen"
            @change="onChangeSwitch"
          />
          <span class="open-text">{{ data.isopen ? '已开启' : '已关闭' }}</span>
        </div>
      </div>
      <!-- 小满主账号： -->
      <div class="row clearfix">
        <label class="fl">小满主帐号：</label>
        <div class="item-wrap">
          <template v-if="data.account">
            <span>{{ data.account }}</span>
            <a
              class="edit-account-btn btn-text"
              :class="{ 'isclose': !data.isopen }"
              @click="handleSetAccountModal('edit')"
            >
              修改
            </a>
          </template>
          <a
            v-else
            class="btn-text"
            :class="{ 'isclose': !data.isopen }"
            @click="handleSetAccountModal('add')"
          >
            绑定
          </a>
        </div>
      </div>
      <!-- 成员对应： -->
      <div class="row clearfix">
        <label class="fl">成员对应：</label>
        <div class="item-wrap">
          <div class="top">
            <a
              v-if="!data.syncusertime"
              class="btn-text"
              :class="{ 'isclose': !data.isopen }"
              @click="handleGetMembers"
            >获取小满成员</a>
            <p v-else>
              <a
                class="btn-text"
                :class="{ 'isclose': !data.isopen }"
                @click="handleGetMembers"
              >重新获取小满成员</a>
              <span class="fs-gray666">（上次获取时间：{{ $moment(data.syncusertime * 1000).format('YYYY-MM-DD HH:mm:ss') }}）</span>
            </p>
            <p class="fs-gray fs-12">
              设置小满成员与星轨成员的对应关系，以保证从星轨推送数据至小满时，可以同步到正确的成员帐号
            </p>
          </div>
          <a-spin
            :spinning="loading"
          >
            <members-list
              :data="data.xiaomanuserassoc"
              :loading="membersLoading"
              :member-options="memberOptions"
              :is-syncfield="isSyncfield"
            />
          </a-spin>
        </div>
      </div>
    </div>
    <set-account-modal
      :visible.sync="showSetAccountModal"
      :type="accountType"
      @setAccount="setAccount"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import SetAccountModal from './SetAccountModal.vue'
import MembersList from './MembersList.vue'

export default {
  name: 'BaseConfigMain',
  components: {
    SetAccountModal,
    MembersList
  },
  data () {
    return {
      data: {
        isopen: 0,
        email: '',
        syncusertime: '',
        xiaomanuserassoc: []
      },
      showSetAccountModal: false,
      accountType: 'add',
      isSyncfield: false
    }
  },

  computed: {
    ...mapState('config/xiaoman', ['baseConfigData', 'loading']),
    ...mapState('config/xiaoman/baseConfig', ['membersLoading', 'listDatas', 'memberOptions'])

  },

  watch: {
    baseConfigData: {
      handler (val) {
        if (!val) return

        this.data = val
      },
      deep: true,
      immediate: true
    }
  },

  mounted () {
    this.fetchPeronsDatas()
  },

  methods: {
    ...mapActions('config/xiaoman/baseConfig', [
      'fetchPeronsDatas',
      'setXiaomanIsOpen',
      'fetchXiaomanSyncMember'
    ]),
    ...mapMutations('config/xiaoman', ['SET_XIAOMAN_OPEN']),

    async onChangeSwitch (checked) {
      let isopen = checked ? 1 : 0
      let chain = await this.setXiaomanIsOpen({
        isopen
      })
      chain
        .onSuccess(res => {
          this.data.isopen = checked ? 1 : 0
          this.SET_XIAOMAN_OPEN(isopen)
        })
    },

    handleSetAccountModal (type) {
      if (!this.data.isopen) return

      this.accountType = type
      this.showSetAccountModal = true
    },

    setAccount (email) {
      this.showSetAccountModal = false
      this.data.account = email
    },

    async handleGetMembers () {
      if (!this.data.isopen) return

      let chain = await this.fetchXiaomanSyncMember()
      chain
        .onSuccess((res = {}) => {
          let { xiaomanuserassoc = [], syncusertime } = res
          this.data.xiaomanuserassoc = []
          xiaomanuserassoc.forEach(item => {
            this.data.xiaomanuserassoc.push(item)
          })
          this.data.syncusertime = syncusertime
          this.isSyncfield = true
        })
    }
  }
}
</script>

<style scoped lang="scss">
.ant-alert {
  margin-bottom: 24px;
}
.ant-alert-message {
  display: none;
}
.ant-alert-with-description {
  padding: 8px 15px;
  line-height: 1;
  z-index: 99;
  .ant-alert-description {
    display: inline-block;
    .fs-warn {
      margin-right: 12px;
    }
  }
}
.ant-switch {
  background-color: #ebebeb;
}
.ant-switch-checked {
  background-color: #5077aa;
}
.content {
  min-width: 1040px;
  .row {
    margin-bottom: 32px;
  }
  .row > label {
    width: 106px;
    height: 24px;
    line-height: 24px;
    padding-right: 12px;
    text-align: right;
  }
  .item-wrap {
    padding-left: 108px;
    line-height: 24px;
  }
  .open-text {
    margin-left: 8px;
  }
  .edit-account-btn {
    margin-left: 8px;
  }
  .isclose {
    opacity: .5;
  }
}
.ant-spin-spinning {
  display: block;
}
</style>
